import {NgModule} from '@angular/core';
import {IonicPageModule} from 'ionic-angular';
import {UpdateRegistrationDocumentPage} from './update-registration-document';

import {IonicSelectableModule} from 'ionic-selectable';
import {BrMaskerModule} from 'brmasker-ionic-3';

@NgModule({
  declarations: [
    UpdateRegistrationDocumentPage,
  ],
  imports: [
    IonicPageModule.forChild(UpdateRegistrationDocumentPage),
    IonicSelectableModule,
    BrMaskerModule,
  ],
  exports: [
    UpdateRegistrationDocumentPage
  ]
})
export class UpdateRegistrationDocumentPageModule {
}



// WEBPACK FOOTER //
// ./src/pages/update-registration-document/update-registration-document.module.ts